import { render, staticRenderFns } from "./ItemSelecao.vue?vue&type=template&id=0db3cbe3"
import script from "./ItemSelecao.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemSelecao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports